import React from 'react';
import {darken, makeStyles} from '@material-ui/core/styles';
import {Box, Card, CardActions, Collapse, TableCell} from '@material-ui/core';
import VectorStepper from "./VectorStepper";
import {Grid} from '@material-ui/core';
import SimpleNumberCard from "../../metrics/SimpleNumberCard";
import IconButton from "@material-ui/core/IconButton";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import clsx from "clsx";
import CardContent from "@material-ui/core/CardContent";
import Typography from "@material-ui/core/Typography";
import Table from "@material-ui/core/Table";
import TableRow from "@material-ui/core/TableRow";
import TableBody from "@material-ui/core/TableBody";
import PhishingAttacksTable from "../PhishingAttacksTable";
import DraftsSharpIcon from '@material-ui/icons/DraftsSharp';
import GolfCourseSharpIcon from '@material-ui/icons/GolfCourseSharp';
import BusinessCenterSharpIcon from '@material-ui/icons/BusinessCenterSharp';
import Tooltip from "@material-ui/core/Tooltip";
import CodeSharpIcon from '@material-ui/icons/CodeSharp';
import PropTypes from "prop-types";
import {
    bbDangerousStringToDate,
    bbFormattedDateString,
     bbIsCampaignPotentiallyBreaching, bbShortenString, filterObject
} from "../../../../util/bbHelpers";
import {Badge} from "reactstrap";
import DesktopWindowsSharpIcon from "@material-ui/icons/DesktopWindowsSharp";
import BBIconHumanTarget from "../../../../assets/bbCustomIcons/BBIconHumanTarget";
import AlternateEmailSharpIcon from "@material-ui/icons/AlternateEmailSharp";
import BBExternalLink from "../../accents/BBExternalLink";

const useStyles = makeStyles(theme => ({
    root: {
        width: '100%',
        textAlign: "center",
    },
    rootInactiveVector: {
        width: '100%',
        textAlign: "center",
        opacity: 0.75
    },
    button: {
        marginRight: theme.spacing(2),
    },
    completed: {
        display: 'inline-block',
    },
    instructions: {
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
    },
    target: {
        backgroundColor: darken("#ffffff", .025),
    },
    targetInactive: {
        backgroundColor: darken("#ffffff", .25),
    },
    capability: {
        backgroundColor: darken("#ffffff", .025),
    },
    expand: {
        transform: 'rotate(0deg)',
        marginLeft: 'auto',
        transition: theme.transitions.create('transform', {
            duration: theme.transitions.duration.shortest,
        }),
    },
    expandOpen: {
        transform: 'rotate(180deg)',
    },
    footer: {

        borderTop: "solid 2px gray",
        borderBottom: "solid 9px gray",
        padding: 0,

    },
    expandIcon: {
        fontSize: 16,
    },
    footNote: {
        marginLeft: theme.spacing(2),
        marginRight: theme.spacing(2),
        fontSize: "smaller",
        color: 'gray'
    },
    subtitle: {
        marginLeft: theme.spacing(2),
        marginRight: theme.spacing(2),
        fontSize: "smaller",
        color: 'gray'
    },
    headerRow: {
        marginTop: theme.spacing(1),
        fontWeight: theme.typography.fontWeightBold,
    },
    headerRowSecondary: {
        marginTop: theme.spacing(3),
        fontWeight: theme.typography.fontWeightBold,
    },
    centerFootNote: {
        marginLeft: 'auto',
        marginRight: 'auto',
        fontSize: "smaller",
        color: 'gray'
},
    wholeBox: {
        margin: 0,
        // border: "5px solid red"
    },
    collapse: {
        backgroundColor: 'gray',
    },
    progressBar : {
        colorPrimary : {
            color: "warning"
        }
    },
    progressBarInactive : {
        colorPrimary : {
            color: "light"
        }

    }
}));

function PhishingVectorCard(props) {
    const classes = useStyles();
    const [expanded, setExpanded] = React.useState(false);

    const {campaign, customerId} = props;


    const {
        ["Target Quantity"]:TargetQuantity,
        ["Created DateTime"]:CreatedDateTime,
        CampaignId,
        Status,
        ["Phishing Profile Details"] : PhishingProfileDetails,
        Attacks
    } = campaign

    const {
        ["Phishing ProfileId"]: PhishingProfileId,
        // Sender,
        Command,
        ["Execution Tactic"]: ExecutionTactic,
        Toolkit,
        ["Email Subject"]: EmailSubject,
        ["Has Attachment"]: HasAttachment,
        ["Attachment Name"]: AttachmentName,
        ["Has Link"]: HasLink,
        ["Landing Page URL"] : LandingPageURL
    } = PhishingProfileDetails ? PhishingProfileDetails : {};

    const hasAttachment = HasAttachment === "1"
    const hasLink = HasLink === "1"

    const {
        OsDetails
    } = Toolkit ? Toolkit : {};

    const {
        // TacticId,
        ["Tactic Name"]: TacticName,
        ["Att&ck Category"]: AttackCategory,
        ["Att&ck Url"]: AttackUrl,
    } = ExecutionTactic ? ExecutionTactic : {};

    const isVectorActive = bbIsCampaignPotentiallyBreaching(campaign);

    // console.log("Building a PhishingVectorCard with campaign: ", campaign, "and customerId", customerId)

    const handleExpandClick = () => {
        setExpanded(!expanded);
    };

    // const getActivityOngoingDays = () => {
    //     if (!CreatedDateTime) {
    //         return "Pending";
    //     } else {
    //         const startDate = bbDangerousStringToDate(CreatedDateTime);
    //         console.log("Campaign was created", startDate)
    //         const now = Date.now();
    //         const daysSinceStart = Math.floor((now - startDate)/1000/60/60/24) + 1;
    //
    //         return isNaN(daysSinceStart) ? "..." : daysSinceStart;
    //     }
    // }

    const getCreatedDateDisplay = () => {
        // date the vector was created
        if (CreatedDateTime) {
            return <Tooltip title={`This phishing vector was identified on ${bbFormattedDateString(CreatedDateTime, "long")}.`}>
                <span>
                    {bbFormattedDateString(CreatedDateTime, "microYear")}
                </span>
            </Tooltip>
        } else {
            return "..."
        }
    }

    const getNumberOfAttackEvents = () => {
        // return (vector && vector.Attacks) ? Object.keys(vector.Attacks).length : "...";
        const numAttacks = Attacks ? Object.keys(Attacks).length : null;
        if (numAttacks !== null) {
            return <Tooltip title={`${numAttacks} attacks have been launched as a part of this vector. For more details, expand the Attack Event table below.`}>
                <span>
                    {numAttacks}
                </span>
            </Tooltip>
        } else {
            return "..."
        }
    }

    const getLastAttackDate = () => {
        if (Attacks && Object.keys(Attacks).length > 0) {

        } else {
            return "N/A"
        }
        //get all dates from attack objects
        const attackDates = []
        for (const attack in Attacks) {
            attackDates.push(bbDangerousStringToDate(Attacks[attack]["Start DateTime"]));
        }

        //sort
        attackDates.sort((a, b) => b - a);

        const earliestDate = attackDates[0];
        // console.log("Earliest Campaign Attack date is", earliestDate)

        return isNaN(earliestDate) ? "..." : bbFormattedDateString(earliestDate, "short");
    }

    // const getLastAttackDate = () => {
    //     // return (vector && vector.Attacks) ? Object.keys(vector.Attacks).length : "...";
    //     return (vector && vector["Attack Totals"]) ? vector["Attack Totals"].lastAttack ? bbFormattedDateString(vector["Attack Totals"].lastAttack, "short") : "N/A" :  "...";
    // }

    const getPercentOfAttacksDefeated = () => {
        // return (vector && vector.Attacks) ? Object.keys(vector.Attacks).length : "...";
        const totalAttackEvents = Attacks ? Object.keys(Attacks).length : null;
        const numAttacksDefeated = Attacks ? Object.keys(filterObject(Attacks, (_, attack) => !attack["Access Gained"] === true)).length : null;
        // console.log("totalAttackEvents ", totalAttackEvents, "numAttacksDefeated", numAttacksDefeated);
        if (totalAttackEvents !== null && totalAttackEvents >= 0 && numAttacksDefeated !== null && numAttacksDefeated >= 0) {
            // console.log("Calculating percentDefeated")
            const percentDefeated = Math.trunc(numAttacksDefeated / totalAttackEvents * 100);
            if (percentDefeated >= 0 && percentDefeated <= 100) {
                //number appears to be a good percentage
                const textColor = percentDefeated === 100 ? "bb-risk-lowest" : percentDefeated >= 90 ? "bb-risk-high" : "bb-risk-highest";
                return <Tooltip title={`${numAttacksDefeated} out of ${totalAttackEvents} attack events have been defeated.`}><span className={`text-${textColor}`}>{`${percentDefeated}%`}</span></Tooltip>
            } else {
                //number is not as expected.
                return <Tooltip title={`Further analysis is required regarding ${numAttacksDefeated} attack events.`}><span>Pending</span></Tooltip>
            }

        } else {
            return <Tooltip title={`No attacks within this vector have occurred yet.`}><small>Pending</small></Tooltip>
        }
    }


    return (
        <Card className={isVectorActive ? classes.root : classes.rootInactiveVector} elevation={10}>
            <Grid container
                  spacing={0}
                  alignItems="stretch"
                  justifyContent="center"
                  direction="row"
                  className={classes.wholeBox}
            >
                <Grid item xs={3} className={classes.capability} >
                    <Box className={classes.headerRowSecondary}>
                        <Tooltip title={"The BreachBits phishing capability that has been matched against these identities."}><h3>Attack Capability</h3></Tooltip>
                        {PhishingProfileId && <Tooltip title={"This vector includes a phishing campaign."}><span><Badge color="warning">Phishing</Badge></span></Tooltip> }
                        {!PhishingProfileId && <br/> }
                        <Table className={classes.table} size="small">
                            <TableBody>
                                <TableRow>
                                    <TableCell>
                                        <Tooltip title={"Tactic"}><span><AlternateEmailSharpIcon/></span></Tooltip>
                                    </TableCell>
                                    <TableCell>
                                        <small>
                                            <BBExternalLink
                                                href={`${AttackUrl}`}
                                                tipText={`Tactic: ${TacticName}. Click to learn more in a new browser tab.`}
                                            >
                                                {`${bbShortenString(TacticName, 50, true)}`}
                                            </BBExternalLink>
                                        </small>

                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell>
                                        <Tooltip title={"Attack Toolkit"}><BusinessCenterSharpIcon/></Tooltip>
                                    </TableCell>
                                    <TableCell>
                                        {Toolkit &&
                                            <Tooltip title={`Toolkit ${Toolkit.Name} ${Toolkit["Description Short"]}. ${Toolkit["Description Long"]}`}><small>{`${bbShortenString(Toolkit.Name, 50, true)}`}</small></Tooltip>
                                        }
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell>
                                        <Tooltip title={"Purpose | Goal of this Vector"}><GolfCourseSharpIcon/></Tooltip>
                                    </TableCell>
                                    <TableCell>
                                        {`Initial Access: ${bbShortenString(AttackCategory, 25, true)}`}
                                    </TableCell>
                                </TableRow>

                            </TableBody>
                        </Table>
                    </Box>
                    <br/>
                    {/*<h4>Toolkit</h4>*/}
                    {Toolkit &&
                        <SimpleNumberCard title={bbShortenString(Toolkit["Description Short"], 35, true)} number={""} topTitle={"Toolkit"} subtitle={`${HasAttachment ? "Attachment" : "No Attachment"} ${HasLink ? "with link" : "without link"}`}/>
                    }
                </Grid>
                <Grid item xs={6}>
                    <Grid

                    >
                        <Grid item xs>
                            <Box className={classes.headerRow}>
                                {/*<h6>Attack Vector:</h6>*/}
                                <Tooltip title={`Email Subject: "${EmailSubject}"`}><h1>{`Spearphish: ${bbShortenString(EmailSubject, 50, true)}`}</h1></Tooltip>
                                <Typography className={classes.subtitle}>{`Spearphishing Email Campaign: ${HasAttachment ? "Attachment" : "No Attachment"} ${HasLink ? "with link" : "without link"}.`}</Typography>
                            </Box>
                        </Grid>
                    </Grid>
                    <Grid container
                          spacing={0}
                          justifyContent="center"
                          direction="row"
                    >
                        <Grid item xs>
                            <Box ><SimpleNumberCard number={getCreatedDateDisplay()} title={"Created"}/></Box>
                        </Grid>
                        <Grid item xs>
                            <Box style={{ cursor: 'pointer'}} onClick={handleExpandClick}>
                                <SimpleNumberCard number={getNumberOfAttackEvents()} title={"Attacks"} />
                            </Box>
                        </Grid>
                        <Grid item xs>
                            <Box style={{ cursor: 'pointer'}} onClick={handleExpandClick}>
                                <SimpleNumberCard number={getPercentOfAttacksDefeated()} title={"Defeated"} />
                            </Box>
                        </Grid>
                    </Grid>
                    <Grid container
                          spacing={0}
                          justifyContent="center"
                          >
                        <Grid item xs>
                            {Status &&
                                <Box style={{width: "100%"}}><VectorStepper currentStatus={Status.Id} isCampaign description={`${bbShortenString(Status.Description, 144, true)}`}/></Box>
                            }
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs className={classes.target}>
                    <Box className={classes.headerRowSecondary}>
                        <Tooltip title={"The human and system targets under attack."}>
                            <h3>Campaign Details</h3>
                        </Tooltip>
                        {/*TODO: indicate if this identity is still detected*/}
                        {/*{isTargetActive && bbScopeIcon(target.OutOfScope)} &nbsp;*/}

                        {/*{!isTargetActive && <Tooltip title={"CIRT cannot detect this target. It has likely moved or been removed."}><span><Badge color="info">INACTIVE</Badge></span></Tooltip> }*/}

                        <Table className={classes.table} size="small">
                            <TableBody>
                                <TableRow>
                                    <TableCell>
                                        <Tooltip title={"Number of Humans Targeted"}><span><BBIconHumanTarget/></span></Tooltip>
                                    </TableCell>
                                    <TableCell>
                                        <Tooltip title={TargetQuantity}><span>{`${bbShortenString(TargetQuantity, 50, true)}`}</span></Tooltip>

                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell>
                                        <Tooltip title={"Vulnerable Systems"}><DesktopWindowsSharpIcon/></Tooltip>
                                    </TableCell>
                                    <TableCell>
                                        <Tooltip title={`${bbShortenString(OsDetails ? OsDetails.Description ? OsDetails.Description : "Pending" : "Pending", 50, true)}`}>
                                        <span>
                                        {(OsDetails && OsDetails.Logo) && (
                                            <img style={{height: 18}} src={OsDetails.Logo} alt={`${bbShortenString(OsDetails.Name, 25, true)}`} />
                                        )}
                                            {(!OsDetails) && (
                                                <>Pending</>
                                            )}
                                        </span>
                                        </Tooltip>

                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell>
                                        <Tooltip title={"Phishing Tactic"}><DraftsSharpIcon/></Tooltip>
                                    </TableCell>
                                    <TableCell>
                                        {HasAttachment &&
                                            <BBExternalLink
                                            href={`https://attack.mitre.org/techniques/T1566/001/`}
                                            tipText={`Phishing: Spearphishing Attachment. Click to learn more at mitre.org in a new browser tab.`}
                                            >
                                                {`Spearphishing Attachment`}
                                            </BBExternalLink>
                                        }
                                        {(HasAttachment && HasLink) && <br/>}
                                        {HasLink &&
                                            <BBExternalLink
                                            href={`https://attack.mitre.org/techniques/T1566/002/`}
                                            tipText={`Phishing: Spearphishing Link. Click to learn more at mitre.org in a new browser tab.`}
                                            >
                                                {`Spearphishing Link`}
                                            </BBExternalLink>
                                        }

                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell>
                                        <Tooltip title={"Attack Code"}><CodeSharpIcon/></Tooltip>
                                    </TableCell>
                                    <TableCell>
                                        <Tooltip title={`${bbShortenString(Command, 500, true)}`}>
                                            <small>
                                                <code>
                                                    {bbShortenString(Command, 25, true)}
                                                </code>
                                            </small>
                                        </Tooltip>

                                    </TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </Box>
                    <br/>
                    {/*{isTargetEmpty && <CircularProgress />}*/}
                    {/*<h4>Payload</h4>*/}
                    {(hasAttachment || hasLink) &&
                        <SimpleNumberCard title={hasAttachment ? `${bbShortenString(AttachmentName, 35, true)}` : hasLink ?`${bbShortenString(LandingPageURL, 35, true)}` : null} number={""} topTitle={"Payload"} subtitle={(hasAttachment && hasLink) ? `${bbShortenString(LandingPageURL, 30, true)}` : null}/>
                    }


                </Grid>

                {/*<Grid container*/}
                {/*      spacing={0}*/}
                {/*      alignItems="stretch"*/}
                {/*      justify="center"*/}
                {/*      direction="row"*/}
                {/*      className={classes.wholeBox}*/}
                {/*>*/}
                {/*    <Grid item xs={12} className={classes.capability} >*/}
                {/*        {isVectorActive && <LinearProgress color="secondary" />}*/}
                {/*        {!isVectorActive && (*/}
                {/*            <>*/}
                {/*                <LinearProgress*/}
                {/*                    variant="determinate"*/}
                {/*                    value = "100"*/}
                {/*                    classes={{progressBar: classes.colorPrimary}}*/}
                {/*                />*/}
                {/*            </>*/}
                {/*        )}*/}
                {/*    </Grid>*/}
                {/*</Grid>*/}

            </Grid>
            <Tooltip title={"Expand to see a table of Attack Events related to this campaign."}>
                <CardActions disableSpacing  className={classes.footer} onClick={handleExpandClick} type={"button"}>
                    {/*<IconButton aria-label="add to favorites">*/}
                    {/*    <FavoriteIcon />*/}
                    {/*</IconButton>*/}
                    {/*<IconButton aria-label="share">*/}
                    {/*    <ShareIcon />*/}
                    {/*</IconButton>*/}

                    <Typography className={classes.footNote} >Last Attack: {getLastAttackDate()}</Typography>
                    <Typography className={classes.centerFootNote} >{`ID: ${bbShortenString(CampaignId, 9)}`}</Typography>
                    <Typography className={classes.footNote} ><strong>Expand for Attack Event details.</strong></Typography>
                    <IconButton
                        className={clsx(classes.expand, {
                            [classes.expandOpen]: expanded,
                        })}

                        aria-expanded={expanded}
                        aria-label="show more"
                    >
                        <ExpandMoreIcon className={classes.expandIcon} />
                    </IconButton>
                </CardActions>
            </Tooltip>
            <Collapse in={expanded} timeout="auto" unmountOnExit className={classes.collapse}>
                <CardContent>
                    <PhishingAttacksTable campaignId={campaign.CampaignId} customerId={customerId}/>
                    {/*Placeholder for each phishing email.*/}
                </CardContent>
            </Collapse>
        </Card>
    );
}

PhishingVectorCard.propTypes = {
    campaign: PropTypes.object.isRequired,
    humans: PropTypes.object,
};

export default PhishingVectorCard;